const VIDEO_EXTENSIONS = [
  '.mp4',
  '.mov',
  '.m4v',
  '.webm',
  '.mkv',
  '.m3u8',
  '.ts',
];

// Strip query string / hash so signed and CDN URLs (e.g. video.mp4?token=...)
// are still classified by their real extension.
const cleanPath = (url: string) => (url || '').split(/[?#]/)[0].toLowerCase();

export const isMp4Url = (url: string) => cleanPath(url).endsWith('.mp4');

export const isVideoUrl = (url: string): boolean => {
  const path = cleanPath(url);
  return VIDEO_EXTENSIONS.some(ext => path.endsWith(ext));
};
